<template>
  <span>
    <span
      v-for="(partnervalue, partnerTag) in partnerTags"
      :key="partnerTag"
      v-b-tooltip.hover.noninteractive
      class="badge"
      :class="className"
      :title="$t('partnerTags:' + partnerTag + '.tooltips.' + partnervalue)"
    >
      {{ $t('partnerTags:' + partnerTag + '.badges.' + partnervalue) }}
    </span>
  </span>
</template>
<script>

import UserApi from 'mixins/UserApi';
import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'SearchPartnerTags',
  directives: { 'b-tooltip': VBTooltip },
  mixins: [UserApi],
  props: {
    // offer ids to this object
    objectData: {
      type: Object,
      default: () => {},
    },
  },
  i18nOptions: { namespaces: ['partnerTags'] },
  computed: {
    partnerTags() {
      if (this.UserApi_checkPermission('search.useLabels')) {
        return this.objectData?.partnerTags || {};
      }
      return {};
    },
    className() {
      const badgeClasses = ['gold', 'silver', 'bronze'];
      const tags = Object.values(this.partnerTags);
      const index = tags[0] - 1;
      if (tags.length) { return `badge-${badgeClasses[index]}`; }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
